import React from 'react';
import { LOGO_URL, LOGO_DARK_URL } from '../../../configs/urlConfigs'; 
import { LOGIN_AFFILIATE_GROUP }   from '../../../configs/staticConfigs';


const LoginHeader = (props) => (
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="login-logo padding-bottom-0 margin-top-100">      
                    <h3 className="d-none-mobile"><img className="logo-width" src={props?.userGroup===LOGIN_AFFILIATE_GROUP ? LOGO_URL : LOGO_DARK_URL} alt="Logo" /> 
                    </h3>
                </div>
            </div>
        </div>
    </div>
);

export default LoginHeader;